var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField, Typography, useTheme } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { X } from 'react-feather';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useLazyGetModelsQuery, useUpdateSerialNumberMutation } from '../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../localization/helpers';
import EditSerialNumbers from './EditSerialNumbers';
var EditAllModels = function (_a) {
    var open = _a.open, onClose = _a.onClose, machineId = _a.machineId;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var _c = __read(useLazyGetModelsQuery(), 2), getMachineModels = _c[0], _d = _c[1], machine = _d.data, isMachineModelFetching = _d.isFetching;
    var _e = __read(useUpdateSerialNumberMutation(), 2), updateSerialNumbers = _e[0], _f = _e[1], isLoading = _f.isLoading, isSuccess = _f.isSuccess;
    var _g = useForm({
        defaultValues: {
            clientId: '',
            machineId: '',
            machineData: []
        }
    }), control = _g.control, reset = _g.reset, setError = _g.setError, handleSubmit = _g.handleSubmit, watch = _g.watch, setValue = _g.setValue, errors = _g.formState.errors;
    var clientId = watch('clientId');
    var clientDisabled = !!clientId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var machineModels = (machine === null || machine === void 0 ? void 0 : machine.models) || [];
    var clients = __spreadArray([], __read(new Map(machineModels.map(function (m) { return [m.clientId, { id: m.clientId, name: m.clientName }]; })).values()), false);
    var fields = useFieldArray({
        name: 'machineData',
        control: control
    }).fields;
    useEffect(function () {
        if (machineId)
            getMachineModels(machineId);
    }, [machineId, getMachineModels]);
    useEffect(function () {
        if (machine)
            reset({
                machineId: machineId
            });
    }, [machineId, machine, reset]);
    useEffect(function () {
        if (clientId && machineModels) {
            var clientModels = machineModels.filter(function (m) { return m.clientId === clientId; });
            var machineData = clientModels.map(function (model) {
                return ({
                    modelNumber: model.modelNumber,
                    serialNumbers: model.serialNumbers.map(function (serialNumber) { return ({ serialNumber: serialNumber }); }),
                    deletedSerialNumbers: []
                });
            });
            setValue('machineData', machineData, { shouldValidate: true });
        }
    }, [clientId, machineModels, setValue]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.record'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var findDuplicateSerialNumber = function (machineData) {
        var e_1, _a, e_2, _b, e_3, _c;
        var allSerialNumbers = machineData.flatMap(function (model, modelIndex) {
            return model.serialNumbers.map(function (s, serialIndex) { return ({
                serialNumber: s.serialNumber.trim().toLowerCase(),
                modelIndex: modelIndex,
                serialIndex: serialIndex
            }); });
        });
        var serialNumberMap = new Map();
        try {
            for (var allSerialNumbers_1 = __values(allSerialNumbers), allSerialNumbers_1_1 = allSerialNumbers_1.next(); !allSerialNumbers_1_1.done; allSerialNumbers_1_1 = allSerialNumbers_1.next()) {
                var _d = allSerialNumbers_1_1.value, serialNumber = _d.serialNumber, modelIndex = _d.modelIndex, serialIndex = _d.serialIndex;
                if (!serialNumberMap.has(serialNumber)) {
                    serialNumberMap.set(serialNumber, []);
                }
                serialNumberMap.get(serialNumber).push({ modelIndex: modelIndex, serialIndex: serialIndex });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allSerialNumbers_1_1 && !allSerialNumbers_1_1.done && (_a = allSerialNumbers_1.return)) _a.call(allSerialNumbers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var hasDuplicates = false;
        try {
            for (var _e = __values(serialNumberMap.values()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var occurrences = _f.value;
                if (occurrences.length > 1) {
                    hasDuplicates = true;
                    try {
                        for (var occurrences_1 = (e_3 = void 0, __values(occurrences)), occurrences_1_1 = occurrences_1.next(); !occurrences_1_1.done; occurrences_1_1 = occurrences_1.next()) {
                            var _g = occurrences_1_1.value, modelIndex = _g.modelIndex, serialIndex = _g.serialIndex;
                            setError("machineData.".concat(modelIndex, ".serialNumbers.").concat(serialIndex, ".serialNumber"), {
                                message: tWithField('validations.isUnique', 'assets.serialNumber')
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (occurrences_1_1 && !occurrences_1_1.done && (_c = occurrences_1.return)) _c.call(occurrences_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return !hasDuplicates;
    };
    var handleSubmitForm = function (updatedMachine) {
        var e_4, _a;
        var isValid = findDuplicateSerialNumber(updatedMachine.machineData);
        if (isValid) {
            var _loop_1 = function (machineData) {
                var machineSerialNumbers = new Set(machineData.serialNumbers.map(function (sr) { return sr.serialNumber; }));
                var machineModel = machineModels.find(function (m) { return m.modelNumber === machineData.modelNumber && m.clientId === updatedMachine.clientId; });
                if (machineModel) {
                    machineData.deletedSerialNumbers = machineModel.serialNumbers.filter(function (sr) { return !machineSerialNumbers.has(sr); });
                }
            };
            try {
                for (var _b = __values(updatedMachine.machineData), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var machineData = _c.value;
                    _loop_1(machineData);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            var prevSerialNumbers_1 = new Set(machineModels
                .filter(function (m) { return m.clientId === updatedMachine.clientId; })
                .flatMap(function (m) { return m.serialNumbers; }));
            var currentSerialNumbers = updatedMachine.machineData.flatMap(function (md) {
                return md.serialNumbers.map(function (sn) { return sn.serialNumber; });
            });
            updatedMachine.addedSerialNumbers = currentSerialNumbers.filter(function (sn) { return !prevSerialNumbers_1.has(sn); });
            updateSerialNumbers(updatedMachine);
        }
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [tWithFunction('actions.updateFunction', 'assets.serialNumbers'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsxs(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: [_jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: _jsx(Grid, { container: true, spacing: 3, p: 1, children: _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clientId', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.client')
                                        }
                                    }, render: function (_a) {
                                        var _b, _c;
                                        var _d = _a.field, onChange = _d.onChange, value = _d.value;
                                        return (_jsxs(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: [_jsx(Autocomplete, { sx: {
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '8px'
                                                        }
                                                    }, disabled: clientDisabled, loading: isMachineModelFetching, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: (_b = clients.find(function (client) { return value === client.id; })) !== null && _b !== void 0 ? _b : null, options: clients, getOptionLabel: function (option) { return option.name; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { disabled: clientDisabled, error: !!errors.clientId, variant: 'outlined', fullWidth: true, label: translate('common.client') }))); }, onChange: function (_, value) {
                                                        onChange(value === null || value === void 0 ? void 0 : value.id);
                                                    }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option.id }), option.name)); } }), _jsx(FormHelperText, { error: true, children: (_c = errors.clientId) === null || _c === void 0 ? void 0 : _c.message })] }));
                                    } }) }) }) }), clientId && (_jsxs(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '16px', children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', children: _jsx(Typography, { variant: 'subtitle1', color: theme.palette.grey[700], children: translate('common.modelNumbers') }) }), fields.map(function (field, index) { return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { p: '8px 16px', gap: 2, flexDirection: 'column', borderRadius: '12px', bgcolor: '#FFFFFF', boxShadow: theme.customShadows.z8, position: 'relative', children: [_jsx(Badge, { overlap: 'circular', badgeContent: index + 1, sx: {
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 10,
                                                    '& .MuiBadge-badge': {
                                                        backgroundColor: '#E4E6EB',
                                                        color: '#161C24'
                                                    }
                                                } }), _jsx(Controller, { name: "machineData.".concat(index, ".modelNumber"), control: control, rules: {
                                                    required: tWithField('validations.fieldIsRequired', 'assets.modelNumber'),
                                                    validate: function (value) {
                                                        var isDuplicate = fields.some(function (item, i) {
                                                            return i !== index && item.modelNumber.toLowerCase() === value.toLowerCase();
                                                        });
                                                        return isDuplicate
                                                            ? tWithField('validations.isUnique', 'assets.modelNumber')
                                                            : true;
                                                    }
                                                }, render: function (_a) {
                                                    var _b, _c, _d, _e, _f, _g, _h;
                                                    var field = _a.field;
                                                    return (_jsxs(FormControl, { disabled: true, fullWidth: true, error: !!((_c = (_b = errors.machineData) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.modelNumber), children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', gap: 1, children: _jsx(TextField, __assign({ disabled: true, size: 'small', label: translate('assets.modelNumber') }, field, { error: !!((_e = (_d = errors.machineData) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.modelNumber), fullWidth: true, children: translate('assets.modelNumber') })) }), _jsx(FormHelperText, { error: true, children: (_h = (_g = (_f = errors.machineData) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.modelNumber) === null || _h === void 0 ? void 0 : _h.message })] }));
                                                } }), _jsx(EditSerialNumbers, { control: control, modelSerialNumberIndex: index, errors: errors, isLoading: isLoading })] }) }) }, field.id)); })] }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', disabled: isLoading, onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { size: 'medium', variant: 'contained', color: 'inherit', disabled: isLoading, onClick: handleSubmit(handleSubmitForm), children: translate('actions.saveChanges') })] })] }));
};
export default EditAllModels;
